export default ["is_exactly"];
